var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('meta',{attrs:{"charset":"UTF-8"}}),_c('router-view'),_c('vue-progress-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }